import React,{useEffect,useRef,useState} from 'react'
import Header from './Header';
import MobileMenu from './MobileMenu';
import Hero from './Hero';
import Footer from './Footer';
import CopyrightFooter from './CopyrightFooter';
import { BrowserRouter as Router, Link, Route, useLocation } from 'react-router-dom';
import { setRefreshPage, setPageRedirect } from '../../features/store/bitrixRefreshPage';
import {useDispatch } from 'react-redux';
import SalesChannelMobile from './SalesChannelMobile';
import CommonQuestions from './CommonQuestions';
import OperationsAndBenefitsMobile from './OperationsAndBenefitsMobile';
import IconClipBoard from "../../assets/svgs/IconOperation/IconClipBoard.svg";
import IconLove from "../../assets/svgs/IconOperation/IconLove.svg";
import IconOperation from "../../assets/svgs/IconOperation/IconOperation.svg";
import IconSearch from "../../assets/svgs/IconOperation/IconSearch.svg";
import IconCheck from "../../assets/svgs/IconOperation/IconCheck.svg";
import IconCleaning from "../../assets/svgs/IconOperation/IconCleaning.svg";
import IconMoney from "../../assets/svgs/IconOperation/IconMoney.svg";
import IconStar from "../../assets/svgs/IconOperation/IconStar.svg";
import AdverstisePropertyMobile from './AdverstisePropertyMobile';
import OurOwnersMobile from './OurOwnersMobile';


function scrollToHash() {
  if (window.location.hash) {
    const targetElement = document.querySelector(window.location.hash);

    if (targetElement) {
      const offset = targetElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  }
}


const NewLandingPageMobile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [pageRedirectHome,setPageRedirectHome] = useState(true);

  useEffect(() => {
    dispatch(setRefreshPage(true));
    if (pageRedirectHome){
      dispatch(setPageRedirect("/home"));
      setPageRedirectHome(false);
    }
    (function(w,d,u){
      var s = d.createElement('script');
      s.async=true;
      s.src=u+'?'+(Date.now()/60000|0);
      var h=d.getElementsByTagName('script')[0];
      h.parentNode.insertBefore(s,h);
    })(window,document,'https://cdn.bitrix24.com.br/b6258237/crm/site_button/loader_33_0ueh9v.js');

    scrollToHash();

    // Adicione um event listener para o caso de o hash mudar após o carregamento inicial
    window.addEventListener('hashchange', scrollToHash);

    // Retire o event listener quando o componente for desmontado
    return () => {
      window.removeEventListener('hashchange', scrollToHash);
    };
  }, []);

  return (
    <>
    {/* <Header/> */}

    <MobileMenu/>

    <div style={{paddingTop:"80px"}}>
      <Hero/>
    </div>

    <OperationsAndBenefitsMobile title={"Como funciona?"}
     IconCard1={IconSearch} IconCard2={IconOperation} IconCard3={IconClipBoard} IconCard4={IconLove}
     firstWordCard1={"Buscamos"} textCard1={" imóveis bem localizados para fazer parte de nossa comunidade."}
     firstWordCard2={"Assessoramos"} textCard2={" a modernização do seu imóvel, valorizando e agilizando sua locação."} 
     firstWordCard3={"Realizamos"} textCard3={" vistoria na entrada e na saída, trazendo maior segurança ao proprietário."}
     firstWordCard4={"Cuidamos"} textCard4={" do seu bem e da gestão do seu imóvel."}
    />

    <div id='beneficios'></div>

    <AdverstisePropertyMobile textBlack={"Tudo para que você desfrute dos benefícios do seu investimento"}
    textPink={"sem preocupação!"}/>

    <OperationsAndBenefitsMobile title={"Com a YOLO você tem:"}
    IconCard1={IconMoney} IconCard2={IconCheck} IconCard3={IconCleaning} IconCard4={IconStar} 
    titleCard1={"Precificação Inteligente"} titleCard2={"Check-in e Check-out"} titleCard3={"Gestão de limpeza"}
    titleCard4={"Serviços de experiência"} 
    textCard1={"Otimizamos o valor das diárias para máxima rentabilidade."}
    textCard2={"Coordenamos check-in e check-out assegurando tranquilidade aos hóspedes."} 
    textCard3={"O suporte à gestão de limpeza inclui lavanderia, garantindo espaços impecáveis em todas as unidades."}
    textCard4={"Elevamos a satisfação dos hóspedes com serviços exclusivos, incentivando reservas recorrentes e memoráveis estadias."}
    heightText='126px'
    />

    <SalesChannelMobile/>

    {/* <AdverstisePropertyMobile textBlack={"Oferecemos atendimento exclusivo com especialistas 24 horas"} pink={false}
    /> */}

    {/* <OurOwnersMobile/>
    <CommonQuestions mobile={true}/> */}

    <section className="footer_one footer_position">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> 

      <section className="pt40 pb40">
        <div className="container">
          <CopyrightFooter />
        </div>
      </section>
    </>
  )
}

export default NewLandingPageMobile;
